<template>
  <svg
    width="104"
    height="61"
    viewBox="0 0 104 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="2.5"
      width="103"
      height="56"
      rx="3.5"
      fill="#333333"
      fill-opacity="0.89"
    />
    <path
      d="M25.0866 47.423C25.148 47.423 25.2009 47.4469 25.2453 47.4947L25.6754 47.9658C25.375 48.3207 25.0081 48.5955 24.5746 48.7901C24.1445 48.9846 23.6257 49.0819 23.0181 49.0819C22.4856 49.0819 22.0027 48.9898 21.5692 48.8054C21.1391 48.6211 20.7704 48.3634 20.4632 48.0323C20.1595 47.7012 19.9239 47.3053 19.7567 46.8445C19.5894 46.3837 19.5058 45.8768 19.5058 45.3238C19.5058 44.7709 19.5928 44.264 19.7669 43.8032C19.9444 43.3424 20.1919 42.9465 20.5093 42.6154C20.8268 42.2843 21.2056 42.0266 21.646 41.8422C22.0897 41.6579 22.5795 41.5658 23.1154 41.5658C23.6376 41.5658 24.1019 41.6511 24.508 41.8218C24.9142 41.9924 25.2675 42.2194 25.5679 42.5027L25.2095 43.0096C25.1856 43.0471 25.1549 43.0779 25.1173 43.1018C25.0832 43.1257 25.0371 43.1376 24.9791 43.1376C24.9142 43.1376 24.8374 43.1052 24.7487 43.0403C24.6633 42.9755 24.549 42.9038 24.4056 42.8253C24.2657 42.7434 24.0916 42.67 23.8834 42.6051C23.6752 42.5403 23.4158 42.5078 23.1052 42.5078C22.7399 42.5078 22.4054 42.5727 22.1016 42.7024C21.7979 42.8287 21.535 43.013 21.3132 43.2554C21.0947 43.4943 20.924 43.7895 20.8012 44.1411C20.6817 44.4893 20.622 44.8835 20.622 45.3238C20.622 45.771 20.6851 46.1686 20.8114 46.5168C20.9377 46.865 21.1118 47.1602 21.3336 47.4026C21.5555 47.6449 21.8166 47.8292 22.117 47.9555C22.4174 48.0818 22.7416 48.145 23.0898 48.145C23.3014 48.145 23.4909 48.133 23.6581 48.1091C23.8288 48.0818 23.9841 48.0426 24.124 47.9914C24.2674 47.9402 24.4022 47.8753 24.5285 47.7968C24.6548 47.7149 24.7794 47.6176 24.9023 47.505C24.9296 47.4811 24.9586 47.4623 24.9893 47.4486C25.02 47.4316 25.0525 47.423 25.0866 47.423ZM27.5904 41.4429V49H26.5869V41.4429H27.5904ZM30.0609 43.7981V49H29.0625V43.7981H30.0609ZM30.2504 42.1904C30.2504 42.2826 30.2316 42.3713 30.194 42.4566C30.1565 42.5386 30.1053 42.6119 30.0404 42.6768C29.979 42.7382 29.9056 42.7877 29.8203 42.8253C29.7349 42.8594 29.6462 42.8765 29.554 42.8765C29.4619 42.8765 29.3748 42.8594 29.2929 42.8253C29.211 42.7877 29.1376 42.7382 29.0728 42.6768C29.0113 42.6119 28.9618 42.5386 28.9243 42.4566C28.8901 42.3713 28.8731 42.2826 28.8731 42.1904C28.8731 42.0948 28.8901 42.0061 28.9243 41.9242C28.9618 41.8388 29.0113 41.7654 29.0728 41.704C29.1376 41.6391 29.211 41.5897 29.2929 41.5555C29.3748 41.518 29.4619 41.4992 29.554 41.4992C29.6462 41.4992 29.7349 41.518 29.8203 41.5555C29.9056 41.5897 29.979 41.6391 30.0404 41.704C30.1053 41.7654 30.1565 41.8388 30.194 41.9242C30.2316 42.0061 30.2504 42.0948 30.2504 42.1904ZM35.1519 44.7709C35.1212 44.8084 35.0904 44.8391 35.0597 44.863C35.0324 44.8835 34.9915 44.8938 34.9368 44.8938C34.8822 44.8938 34.8242 44.8733 34.7628 44.8323C34.7047 44.7879 34.6296 44.7419 34.5375 44.6941C34.4487 44.6429 34.3395 44.5968 34.2098 44.5558C34.0835 44.5115 33.9265 44.4893 33.7388 44.4893C33.493 44.4893 33.2763 44.5337 33.0885 44.6224C32.9008 44.7111 32.7438 44.8374 32.6175 45.0013C32.4946 45.1651 32.4007 45.3648 32.3359 45.6003C32.271 45.8358 32.2386 46.1004 32.2386 46.3939C32.2386 46.6977 32.2727 46.9691 32.341 47.208C32.4093 47.4435 32.5065 47.6432 32.6328 47.807C32.7591 47.9675 32.9127 48.0903 33.0936 48.1757C33.2745 48.2576 33.4759 48.2986 33.6978 48.2986C33.9128 48.2986 34.0903 48.273 34.2303 48.2218C34.3702 48.1671 34.4863 48.1091 34.5784 48.0477C34.6706 47.9862 34.7474 47.9299 34.8088 47.8787C34.8703 47.8241 34.9334 47.7968 34.9983 47.7968C35.0802 47.7968 35.1433 47.8275 35.1877 47.889L35.4744 48.2576C35.355 48.4044 35.2201 48.529 35.07 48.6314C34.9232 48.7338 34.7662 48.8174 34.5989 48.8822C34.4317 48.9471 34.2559 48.9949 34.0716 49.0256C33.8907 49.0563 33.7063 49.0717 33.5186 49.0717C33.1943 49.0717 32.8905 49.0119 32.6072 48.8925C32.3273 48.773 32.0833 48.5989 31.8751 48.3702C31.6703 48.1415 31.5081 47.8617 31.3887 47.5306C31.2692 47.1961 31.2095 46.8172 31.2095 46.3939C31.2095 46.0082 31.2624 45.6515 31.3682 45.3238C31.4774 44.9962 31.6361 44.7146 31.8444 44.479C32.056 44.2401 32.3154 44.0541 32.6226 43.921C32.9298 43.7844 33.2814 43.7162 33.6773 43.7162C34.0494 43.7162 34.3771 43.7759 34.6604 43.8954C34.9437 44.0148 35.1963 44.1838 35.4181 44.4022L35.1519 44.7709ZM37.4048 41.4429V45.8614H37.6404C37.712 45.8614 37.7718 45.8512 37.8196 45.8307C37.8673 45.8102 37.9168 45.7693 37.968 45.7078L39.5245 43.9926C39.5723 43.9278 39.6252 43.88 39.6832 43.8493C39.7413 43.8151 39.8147 43.7981 39.9034 43.7981H40.8148L38.9767 45.8102C38.8777 45.9365 38.7719 46.0338 38.6592 46.1021C38.7241 46.1465 38.7804 46.1977 38.8282 46.2557C38.8794 46.3137 38.9289 46.3769 38.9767 46.4451L40.9325 49H40.0365C39.9546 49 39.8829 48.9863 39.8215 48.959C39.7635 48.9317 39.7105 48.8822 39.6628 48.8106L38.0551 46.7216C38.0039 46.6431 37.9527 46.5936 37.9015 46.5731C37.8503 46.5492 37.7735 46.5373 37.6711 46.5373H37.4048V49H36.4064V41.4429H37.4048ZM45.8946 49.0819C45.4748 49.0819 45.1505 48.9642 44.9218 48.7286C44.6965 48.4931 44.5839 48.1569 44.5839 47.72V44.607H43.9797C43.9217 44.607 43.8722 44.59 43.8312 44.5558C43.7937 44.5183 43.7749 44.4637 43.7749 44.392V43.9875L44.6197 43.8698L44.845 42.3184C44.8587 42.2604 44.8843 42.216 44.9218 42.1853C44.9628 42.1511 45.014 42.1341 45.0754 42.1341H45.5823V43.88H47.0568V44.607H45.5823V47.6534C45.5823 47.8582 45.6318 48.0118 45.7308 48.1142C45.8332 48.2132 45.9629 48.2627 46.1199 48.2627C46.212 48.2627 46.2905 48.2508 46.3554 48.2269C46.4237 48.203 46.4817 48.1774 46.5295 48.1501C46.5773 48.1194 46.6182 48.0921 46.6524 48.0682C46.6865 48.0443 46.7172 48.0323 46.7445 48.0323C46.7787 48.0323 46.8043 48.0409 46.8213 48.0579C46.8418 48.0716 46.8623 48.0955 46.8828 48.1296L47.1797 48.6109C47.0159 48.7611 46.8213 48.8771 46.596 48.959C46.3708 49.041 46.1369 49.0819 45.8946 49.0819ZM50.1634 43.7162C50.5457 43.7162 50.8904 43.7793 51.1976 43.9056C51.5083 44.0285 51.7711 44.2077 51.9861 44.4432C52.2046 44.6753 52.3718 44.9569 52.4879 45.288C52.6039 45.6157 52.662 45.9843 52.662 46.3939C52.662 46.8035 52.6039 47.1739 52.4879 47.505C52.3718 47.8361 52.2046 48.1177 51.9861 48.3498C51.7711 48.5819 51.5083 48.7611 51.1976 48.8874C50.8904 49.0102 50.5457 49.0717 50.1634 49.0717C49.7777 49.0717 49.4295 49.0102 49.1189 48.8874C48.8117 48.7611 48.5489 48.5819 48.3304 48.3498C48.112 48.1177 47.943 47.8361 47.8236 47.505C47.7075 47.1739 47.6495 46.8035 47.6495 46.3939C47.6495 45.9843 47.7075 45.6157 47.8236 45.288C47.943 44.9569 48.112 44.6753 48.3304 44.4432C48.5489 44.2077 48.8117 44.0285 49.1189 43.9056C49.4295 43.7793 49.7777 43.7162 50.1634 43.7162ZM50.1634 48.2934C50.6549 48.2934 51.0219 48.1279 51.2642 47.7968C51.5065 47.4657 51.6277 46.9998 51.6277 46.399C51.6277 45.7983 51.5065 45.3324 51.2642 45.0013C51.0219 44.6668 50.6549 44.4995 50.1634 44.4995C49.6651 44.4995 49.293 44.6668 49.0472 45.0013C48.8049 45.3324 48.6837 45.7983 48.6837 46.399C48.6837 46.9998 48.8049 47.4657 49.0472 47.7968C49.293 48.1279 49.6651 48.2934 50.1634 48.2934ZM59.4384 48.1245C59.732 48.1245 59.9948 48.075 60.2269 47.976C60.459 47.877 60.6553 47.7388 60.8157 47.5613C60.9761 47.3804 61.099 47.167 61.1844 46.9213C61.2697 46.6721 61.3124 46.3973 61.3124 46.097V41.6477H62.3978V46.097C62.3978 46.527 62.3295 46.9247 62.193 47.2899C62.0565 47.6551 61.8602 47.9709 61.6042 48.2371C61.3482 48.5034 61.0376 48.7116 60.6724 48.8618C60.3071 49.0119 59.8958 49.087 59.4384 49.087C58.9811 49.087 58.5697 49.0119 58.2045 48.8618C57.8393 48.7116 57.5287 48.5034 57.2727 48.2371C57.0167 47.9709 56.8204 47.6551 56.6839 47.2899C56.5473 46.9247 56.4791 46.527 56.4791 46.097V41.6477H57.5696V46.0918C57.5696 46.3922 57.6106 46.667 57.6925 46.9162C57.7779 47.1653 57.9007 47.3804 58.0612 47.5613C58.2216 47.7388 58.4179 47.877 58.65 47.976C58.8821 48.075 59.1449 48.1245 59.4384 48.1245ZM64.7548 47.72C64.9187 47.935 65.0945 48.0852 65.2822 48.1706C65.4733 48.2559 65.6867 48.2986 65.9222 48.2986C66.3796 48.2986 66.7329 48.1347 66.982 47.807C67.2346 47.4759 67.3609 46.9947 67.3609 46.3632C67.3609 46.0321 67.3319 45.7505 67.2739 45.5184C67.2193 45.2829 67.1373 45.0917 67.0281 44.945C66.9223 44.7948 66.7909 44.6855 66.6339 44.6173C66.4769 44.5456 66.2994 44.5098 66.1014 44.5098C65.8113 44.5098 65.5587 44.5746 65.3436 44.7043C65.132 44.834 64.9357 45.0183 64.7548 45.2573V47.72ZM64.7036 44.5763C64.8129 44.4466 64.9289 44.3289 65.0518 44.223C65.1781 44.1138 65.3129 44.0217 65.4563 43.9466C65.5996 43.8681 65.7515 43.8083 65.912 43.7674C66.0758 43.723 66.2499 43.7008 66.4342 43.7008C66.7312 43.7008 66.9991 43.7588 67.238 43.8749C67.4804 43.9909 67.6869 44.1616 67.8576 44.3869C68.0282 44.6122 68.1596 44.8903 68.2518 45.2214C68.3474 45.5525 68.3952 45.9331 68.3952 46.3632C68.3952 46.7489 68.3423 47.1073 68.2364 47.4384C68.134 47.7661 67.9856 48.0511 67.791 48.2934C67.5999 48.5358 67.3643 48.7269 67.0844 48.8669C66.808 49.0034 66.4956 49.0717 66.1475 49.0717C65.8369 49.0717 65.5706 49.0205 65.3488 48.9181C65.1269 48.8157 64.9289 48.6723 64.7548 48.488V50.7459H63.7564V43.7981H64.3555C64.4954 43.7981 64.5825 43.8646 64.6166 43.9978L64.7036 44.5763ZM70.5404 41.4429V49H69.5369V41.4429H70.5404ZM74.1834 43.7162C74.5657 43.7162 74.9104 43.7793 75.2176 43.9056C75.5283 44.0285 75.7911 44.2077 76.0061 44.4432C76.2246 44.6753 76.3918 44.9569 76.5079 45.288C76.6239 45.6157 76.682 45.9843 76.682 46.3939C76.682 46.8035 76.6239 47.1739 76.5079 47.505C76.3918 47.8361 76.2246 48.1177 76.0061 48.3498C75.7911 48.5819 75.5283 48.7611 75.2176 48.8874C74.9104 49.0102 74.5657 49.0717 74.1834 49.0717C73.7977 49.0717 73.4495 49.0102 73.1389 48.8874C72.8317 48.7611 72.5689 48.5819 72.3504 48.3498C72.132 48.1177 71.963 47.8361 71.8436 47.505C71.7275 47.1739 71.6695 46.8035 71.6695 46.3939C71.6695 45.9843 71.7275 45.6157 71.8436 45.288C71.963 44.9569 72.132 44.6753 72.3504 44.4432C72.5689 44.2077 72.8317 44.0285 73.1389 43.9056C73.4495 43.7793 73.7977 43.7162 74.1834 43.7162ZM74.1834 48.2934C74.6749 48.2934 75.0419 48.1279 75.2842 47.7968C75.5265 47.4657 75.6477 46.9998 75.6477 46.399C75.6477 45.7983 75.5265 45.3324 75.2842 45.0013C75.0419 44.6668 74.6749 44.4995 74.1834 44.4995C73.6851 44.4995 73.313 44.6668 73.0672 45.0013C72.8249 45.3324 72.7037 45.7983 72.7037 46.399C72.7037 46.9998 72.8249 47.4657 73.0672 47.7968C73.313 48.1279 73.6851 48.2934 74.1834 48.2934ZM80.592 46.6909C80.1858 46.7045 79.841 46.737 79.5577 46.7882C79.2744 46.8359 79.044 46.9008 78.8665 46.9827C78.689 47.0646 78.561 47.1619 78.4825 47.2746C78.404 47.3838 78.3648 47.5067 78.3648 47.6432C78.3648 47.7729 78.3852 47.8855 78.4262 47.9811C78.4706 48.0733 78.5286 48.1501 78.6003 48.2115C78.6754 48.2695 78.7624 48.3122 78.8614 48.3395C78.9604 48.3668 79.0679 48.3805 79.184 48.3805C79.3376 48.3805 79.4775 48.3651 79.6038 48.3344C79.7335 48.3037 79.8547 48.261 79.9673 48.2064C80.08 48.1484 80.1875 48.0784 80.2899 47.9965C80.3923 47.9146 80.493 47.8207 80.592 47.7149V46.6909ZM77.6633 44.5251C77.9535 44.2486 78.2675 44.0421 78.6054 43.9056C78.9467 43.7691 79.3205 43.7008 79.7267 43.7008C80.0236 43.7008 80.2865 43.7503 80.5152 43.8493C80.7439 43.9449 80.9367 44.0797 81.0937 44.2538C81.2507 44.4278 81.3685 44.6361 81.447 44.8784C81.5289 45.1207 81.5699 45.3887 81.5699 45.6822V49H81.1244C81.0255 49 80.9504 48.9846 80.8992 48.9539C80.848 48.9198 80.807 48.8583 80.7763 48.7696L80.6688 48.3139C80.5356 48.4368 80.4042 48.546 80.2745 48.6416C80.1448 48.7338 80.0083 48.814 79.8649 48.8822C79.725 48.9471 79.5748 48.9966 79.4144 49.0307C79.2539 49.0649 79.0764 49.0819 78.8819 49.0819C78.6771 49.0819 78.4842 49.0546 78.3033 49C78.1258 48.942 77.9705 48.8549 77.8374 48.7389C77.7043 48.6228 77.5985 48.4778 77.52 48.3037C77.4449 48.1296 77.4073 47.9265 77.4073 47.6944C77.4073 47.4896 77.4619 47.2933 77.5712 47.1056C77.6838 46.9145 77.8647 46.7438 78.1139 46.5936C78.3665 46.4434 78.6941 46.3205 79.0969 46.225C79.5031 46.1294 80.0015 46.0748 80.592 46.0611V45.6822C80.592 45.2897 80.5083 44.9962 80.3411 44.8016C80.1738 44.607 79.9281 44.5098 79.6038 44.5098C79.3853 44.5098 79.201 44.5371 79.0508 44.5917C78.9041 44.6463 78.7761 44.7077 78.6668 44.776C78.561 44.8409 78.4672 44.9006 78.3852 44.9552C78.3067 45.0098 78.2248 45.0371 78.1395 45.0371C78.0712 45.0371 78.0115 45.0183 77.9603 44.9808C77.9125 44.9433 77.8732 44.8989 77.8425 44.8477L77.6633 44.5251ZM86.26 45.0576C86.0962 44.8426 85.9187 44.6924 85.7276 44.607C85.5398 44.5217 85.3282 44.479 85.0927 44.479C84.6353 44.479 84.2803 44.6446 84.0277 44.9757C83.7785 45.3034 83.654 45.7829 83.654 46.4144C83.654 46.7455 83.6813 47.0288 83.7359 47.2643C83.7939 47.4964 83.8758 47.6876 83.9816 47.8378C84.0909 47.9845 84.224 48.0938 84.381 48.1654C84.538 48.2337 84.7155 48.2678 84.9135 48.2678C85.2036 48.2678 85.4545 48.203 85.6661 48.0733C85.8777 47.9436 86.0757 47.761 86.26 47.5254V45.0576ZM87.2636 41.4429V49H86.6594C86.5195 49 86.4324 48.9334 86.3983 48.8003L86.3112 48.2013C86.0894 48.4641 85.8368 48.6757 85.5535 48.8362C85.2736 48.9932 84.9493 49.0717 84.5807 49.0717C84.2837 49.0717 84.0141 49.0137 83.7717 48.8976C83.5328 48.7815 83.328 48.6126 83.1573 48.3907C82.9867 48.1654 82.8552 47.8873 82.7631 47.5562C82.6709 47.2251 82.6248 46.8445 82.6248 46.4144C82.6248 46.0287 82.676 45.6703 82.7784 45.3392C82.8808 45.0081 83.0293 44.7214 83.2239 44.479C83.4184 44.2367 83.654 44.0473 83.9304 43.9107C84.2069 43.7708 84.5192 43.7008 84.8674 43.7008C85.1814 43.7008 85.4477 43.752 85.6661 43.8544C85.888 43.9568 86.086 44.1019 86.26 44.2896V41.4429H87.2636Z"
      fill="white"
    />
    <g filter="url(#filter0_d_86_23538)">
      <path
        d="M54.3837 15.9759L51.0773 20.2288C50.9734 20.3838 50.7657 20.401 50.6099 20.2804L46.4899 17.0606C46.3341 16.9573 46.3167 16.7507 46.4379 16.5957L50.7311 11.172C50.8349 11.017 51.0427 10.9998 51.1985 11.1204L54.1933 13.462L54.3837 15.9759Z"
        fill="#828DAB"
      />
    </g>
    <path
      d="M52.9811 13.9269L50.9903 12.3772C50.9557 12.3428 50.9384 12.2911 50.973 12.2223C51.0076 12.1878 51.0595 12.1706 51.1288 12.205L53.1195 13.7547C53.1542 13.7891 53.1715 13.8408 53.1369 13.9097C53.0849 13.9613 53.033 13.9613 52.9811 13.9269Z"
      fill="#2E3746"
    />
    <path
      d="M51.389 13.4448L50.6446 12.8421C50.61 12.8077 50.5926 12.756 50.6273 12.6872C50.6619 12.6355 50.7138 12.6355 50.7831 12.6699L51.5274 13.2726C51.5621 13.307 51.5794 13.3587 51.5448 13.4275C51.4928 13.4792 51.4236 13.4792 51.389 13.4448Z"
      fill="#2E3746"
    />
    <path
      d="M54.1931 13.4619L53.2756 14.6155C53.1371 14.7877 53.1891 15.0287 53.3449 15.1492L54.4009 15.9757"
      fill="#2E3746"
    />
    <path
      d="M53.1022 16.2341L52.0635 15.4421L50.9902 14.5984L50.0035 13.8236C49.8996 13.7375 49.7265 13.7547 49.64 13.8752L48.2205 15.6659C48.1339 15.7692 48.1512 15.9414 48.2551 16.0275L51.3711 18.4725C51.4749 18.5586 51.648 18.5414 51.7346 18.4208L53.1541 16.6302C53.2407 16.4752 53.2233 16.3374 53.1022 16.2341ZM49.8131 16.2169L50.1247 15.8037L51.0768 16.5441L50.7652 16.9573L49.8131 16.2169ZM50.6786 17.0778L50.3843 17.4566L49.4322 16.7162L49.7265 16.3374L50.6786 17.0778ZM51.4922 16.0275L51.1806 16.4408L50.2285 15.7004L50.5401 15.2871L51.4922 16.0275ZM50.6267 15.1666L50.9729 14.7534L51.925 15.4937L51.6134 15.907L50.6267 15.1666ZM52.3578 17.3533L51.3018 16.5268L51.6134 16.1136L52.6694 16.9401L52.3578 17.3533ZM50.1074 15.5971L49.086 14.805L49.3976 14.3918L50.419 15.1838L50.1074 15.5971ZM48.9821 14.9255L50.0035 15.7176L49.6919 16.1308L48.6705 15.3388L48.9821 14.9255ZM51.2153 16.6474L52.2712 17.4738L51.9596 17.8871L50.9037 17.0606L51.2153 16.6474ZM53.0329 16.5096L52.7733 16.8368L51.7173 16.0103L52.0289 15.5971L52.9983 16.3547C53.0675 16.3891 53.0676 16.458 53.0329 16.5096ZM49.8996 13.9097L50.8344 14.6501L50.5228 15.0633L49.5015 14.2713L49.7611 13.9441C49.7958 13.8925 49.865 13.8925 49.8996 13.9097ZM48.3416 15.7348L48.5667 15.4593L49.588 16.2513L49.2937 16.6302L48.3416 15.8898C48.307 15.8553 48.307 15.7692 48.3416 15.7348ZM51.4749 18.3003L50.5055 17.5427L50.7998 17.1639L51.8558 17.9904L51.6134 18.2831C51.5788 18.352 51.5096 18.352 51.4749 18.3003Z"
      fill="#2E3746"
    />
    <path
      d="M62.4413 18.6929H43.7961C43.4127 18.6929 43.0771 19.0268 43.0771 19.4083V31.3783C43.0771 31.7598 43.4127 31.6167 43.7961 31.6167H62.3933C62.7768 31.6167 63.1123 31.7598 63.1123 31.3783V19.4083C63.1602 19.0268 62.8247 18.6929 62.4413 18.6929Z"
      fill="#262A31"
    />
    <path
      d="M61.8147 19.3884H44.463C44.1062 19.3884 43.7939 19.6872 43.7939 20.0288V30.7448C43.7939 31.0864 44.1062 30.9583 44.463 30.9583H61.7701C62.127 30.9583 62.4392 31.0864 62.4392 30.7448V20.0288C62.4838 19.6872 62.1716 19.3884 61.8147 19.3884Z"
      fill="#B5BBCC"
    />
    <path
      d="M65.9399 30.949V31.3305C65.9399 31.7597 65.5565 32.1412 65.1251 32.1412H41.1117C40.6803 32.1412 40.2969 31.7597 40.2969 31.3305V30.949H65.9399Z"
      fill="#919AB0"
    />
    <path
      d="M55.3473 30.949V31.092C55.3473 31.3305 55.1556 31.5689 54.868 31.5689H51.3211C51.0815 31.5689 50.8418 31.3782 50.8418 31.092V30.949H55.3473Z"
      fill="#262A31"
    />
    <path
      d="M55.0118 24.9404H53.4301V23.3667C53.4301 23.1759 53.2863 23.0328 53.0946 23.0328C52.9028 23.0328 52.759 23.1759 52.759 23.3667V24.9404H51.1773C50.9856 24.9404 50.8418 25.0835 50.8418 25.2742C50.8418 25.465 50.9856 25.6081 51.1773 25.6081H52.759V27.1818C52.759 27.3726 52.9028 27.5156 53.0946 27.5156C53.2863 27.5156 53.4301 27.3726 53.4301 27.1818V25.6081H55.0118C55.2035 25.6081 55.3473 25.465 55.3473 25.2742C55.3473 25.0835 55.2035 24.9404 55.0118 24.9404Z"
      fill="#8E96AB"
    />
    <g filter="url(#filter1_d_86_23538)">
      <path
        d="M65.893 24.7745L60.5905 27.6295C60.284 27.7928 59.9038 27.6824 59.7363 27.3769L56.996 22.3269C56.8321 22.0217 56.9431 21.643 57.25 21.4762L62.5524 18.6212C62.8589 18.458 63.2392 18.5683 63.4067 18.8739L66.1505 23.9243C66.3144 24.2294 66.1995 24.6113 65.893 24.7745Z"
        fill="url(#paint0_linear_86_23538)"
      />
    </g>
    <path
      d="M65.1896 24.176L60.5275 26.6859C60.397 26.7576 60.2333 26.7071 60.1615 26.5772L57.8958 22.4013C57.824 22.2714 57.8747 22.1084 58.0052 22.0368L62.6673 19.5268C62.7979 19.4552 62.9615 19.5057 63.0334 19.6356L65.299 23.8115C65.3709 23.9414 65.3202 24.1044 65.1896 24.176Z"
      fill="#5B6379"
    />
    <path
      d="M62.0939 23.8003L60.3917 24.7162L60.72 23.2998L62.0939 23.8003Z"
      fill="#474E61"
    />
    <path
      d="M63.5015 23.0417L61.0514 24.3624L61.5252 22.3237L63.5015 23.0417Z"
      fill="#2E3746"
    />
    <path
      d="M60.109 23.1024C60.3094 23.1247 60.49 22.9809 60.5124 22.7813C60.5348 22.5817 60.3905 22.4019 60.1901 22.3796C59.9896 22.3574 59.809 22.5012 59.7866 22.7007C59.7642 22.9003 59.9085 23.0802 60.109 23.1024Z"
      fill="#474E61"
    />
    <g filter="url(#filter2_d_86_23538)">
      <path
        d="M66.4745 25.8614L60.4462 25.98C60.0985 25.9853 59.8115 25.7137 59.8035 25.3658L59.6966 19.6282C59.6917 19.2823 59.9649 18.9964 60.3145 18.9881L66.3429 18.8695C66.6905 18.8642 66.9776 19.1358 66.9855 19.4837L67.0954 25.2233C67.1003 25.5692 66.8222 25.8561 66.4745 25.8614Z"
        fill="url(#paint1_linear_86_23538)"
      />
    </g>
    <path
      d="M66.1254 25.0086L60.8252 25.1126C60.6762 25.1167 60.554 24.9973 60.55 24.849L60.4619 20.1047C60.458 19.9565 60.5782 19.8348 60.7272 19.8307L66.0274 19.7266C66.1764 19.7225 66.2986 19.842 66.3025 19.9903L66.3906 24.7345C66.3946 24.8828 66.2744 25.0045 66.1254 25.0086Z"
      fill="#93A0C4"
    />
    <path
      d="M63.5483 23.2629L61.6133 23.3003L62.558 22.1914L63.5483 23.2629Z"
      fill="#475773"
    />
    <path
      d="M65.1474 23.2304L62.3612 23.2865L63.7222 21.6909L65.1474 23.2304Z"
      fill="#4B5A73"
    />
    <path
      d="M62.1047 21.7373C62.2725 21.8485 62.4994 21.8031 62.6113 21.636C62.7232 21.4688 62.6779 21.2432 62.51 21.132C62.3421 21.0208 62.1153 21.0662 62.0034 21.2333C61.8915 21.4005 61.9368 21.6261 62.1047 21.7373Z"
      fill="#475773"
    />
    <path
      d="M66.5358 26.075L65.2571 26.4672L66.2756 27.9653L65.4456 28.5235L64.4272 27.0254L63.585 28.0596L62.8573 23.8266L66.5358 26.075Z"
      fill="#C8D1E8"
    />
    <g filter="url(#filter3_d_86_23538)">
      <path
        d="M41.2088 19.6453L44.4499 23.2175C44.5589 23.3412 44.5251 23.5427 44.381 23.6723L40.2667 27.3717C40.1225 27.5013 39.9155 27.5062 39.8115 27.3881L35.7117 22.7347C35.6027 22.6111 35.6365 22.4095 35.7806 22.2799L38.7615 19.5997L41.2088 19.6453Z"
        fill="#A9B7DE"
      />
    </g>
    <path
      d="M38.6113 19.4281L39.5435 20.5233C39.6745 20.6771 39.9153 20.6856 40.07 20.5553L41.0473 19.7323"
      fill="#2E3746"
    />
    <g clip-path="url(#clip0_86_23538)">
      <path
        d="M37.724 20.2706L37.4863 20.4707L37.6246 20.6332L37.8623 20.4331L37.724 20.2706Z"
        fill="#2E3746"
      />
      <path
        d="M38.1019 20.2309L37.8643 20.4311L38.0026 20.5936L38.2402 20.3934L38.1019 20.2309Z"
        fill="#2E3746"
      />
      <path
        d="M37.9984 20.5933L37.7607 20.7934L37.8991 20.9559L38.1367 20.7557L37.9984 20.5933Z"
        fill="#2E3746"
      />
      <path
        d="M38.3773 20.5537L38.1396 20.7538L38.278 20.9163L38.5156 20.7162L38.3773 20.5537Z"
        fill="#2E3746"
      />
      <path
        d="M38.2758 20.9183L38.0381 21.1184L38.1764 21.2809L38.4141 21.0808L38.2758 20.9183Z"
        fill="#2E3746"
      />
      <path
        d="M38.6537 20.8787L38.416 21.0788L38.5543 21.2413L38.792 21.0411L38.6537 20.8787Z"
        fill="#2E3746"
      />
      <path
        d="M38.5502 21.241L38.3125 21.4411L38.4508 21.6036L38.6885 21.4035L38.5502 21.241Z"
        fill="#2E3746"
      />
      <path
        d="M38.9281 21.2013L38.6904 21.4015L38.8287 21.564L39.0664 21.3638L38.9281 21.2013Z"
        fill="#2E3746"
      />
      <path
        d="M38.8265 21.566L38.5889 21.7661L38.7272 21.9286L38.9649 21.7285L38.8265 21.566Z"
        fill="#2E3746"
      />
      <path
        d="M39.2045 21.5264L38.9668 21.7265L39.1051 21.889L39.3428 21.6889L39.2045 21.5264Z"
        fill="#2E3746"
      />
      <path
        d="M39.101 21.8887L38.8633 22.0888L39.0016 22.2513L39.2393 22.0512L39.101 21.8887Z"
        fill="#2E3746"
      />
      <path
        d="M39.4799 21.8491L39.2422 22.0492L39.3805 22.2117L39.6182 22.0115L39.4799 21.8491Z"
        fill="#2E3746"
      />
      <path
        d="M39.3783 22.2137L39.1406 22.4138L39.2789 22.5763L39.5166 22.3762L39.3783 22.2137Z"
        fill="#2E3746"
      />
      <path
        d="M39.7543 22.1718L39.5166 22.3719L39.6549 22.5344L39.8926 22.3343L39.7543 22.1718Z"
        fill="#2E3746"
      />
      <path
        d="M39.6527 22.5364L39.415 22.7365L39.5534 22.899L39.791 22.6989L39.6527 22.5364Z"
        fill="#2E3746"
      />
      <path
        d="M40.0306 22.4968L39.793 22.6969L39.9313 22.8594L40.169 22.6593L40.0306 22.4968Z"
        fill="#2E3746"
      />
      <path
        d="M39.6914 23.0615L40.3382 23.8214L40.8158 23.4191L40.1691 22.6593L39.6914 23.0615ZM40.6839 23.4084L40.3493 23.6902L40.1623 23.4705L40.4969 23.1887L40.6839 23.4084Z"
        fill="#2E3746"
      />
      <path
        d="M40.7704 25.4602L40.7586 25.0693C40.7601 25.0013 40.7602 24.9502 40.7636 24.8844L40.7617 24.8821L40.5009 25.1017L40.3782 24.9575L40.8651 24.5475L40.9586 24.6573L40.9699 25.029C40.9707 25.0951 40.9719 25.157 40.9645 25.2181L40.9665 25.2204L41.2526 24.9795L41.3773 25.126L40.8581 25.5632L40.7704 25.4602Z"
        fill="#2E3746"
      />
      <path
        d="M41.071 24.0912C41.1139 24.1416 41.1097 24.2158 41.0497 24.2663C40.992 24.3149 40.9178 24.3068 40.8749 24.2564C40.8278 24.2057 40.8319 24.1315 40.8919 24.081C40.9539 24.0327 41.0262 24.0386 41.071 24.0912ZM41.5228 25.0036L41.0221 24.4154L41.2067 24.2599L41.7073 24.8481L41.5228 25.0036Z"
        fill="#2E3746"
      />
      <path
        d="M41.5217 24.3324C41.4555 24.2546 41.3967 24.1902 41.3496 24.1395L41.5088 24.0054L41.5882 24.08L41.5905 24.0781C41.5817 23.9794 41.6194 23.8887 41.7071 23.8148C41.8363 23.706 42.0495 23.7191 42.2092 23.9067C42.3923 24.1219 42.3419 24.3372 42.2081 24.4499C42.1365 24.5102 42.0558 24.527 41.997 24.5137L41.9947 24.5157L42.244 24.8086L42.0594 24.9641L41.5217 24.3324V24.3324ZM41.8252 24.3166C41.8369 24.3303 41.8509 24.3421 41.8629 24.3516C41.9173 24.3922 41.9923 24.3919 42.0454 24.3472C42.1261 24.2792 42.1158 24.174 42.0301 24.0733C41.9502 23.9794 41.8483 23.9435 41.7652 24.0134C41.7121 24.0581 41.6991 24.1359 41.7343 24.2005C41.7398 24.2116 41.7472 24.225 41.757 24.2365L41.8252 24.3166V24.3166Z"
        fill="#2E3746"
      />
    </g>
    <rect
      x="0.5"
      y="2.5"
      width="103"
      height="56"
      rx="3.5"
      stroke="var(--livi-primary)"
      stroke-dasharray="5 5"
    />
    <defs>
      <filter
        id="filter0_d_86_23538"
        x="24.3584"
        y="0.0412598"
        width="52.0254"
        height="53.3183"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_86_23538"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_86_23538"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_86_23538"
        x="34.9209"
        y="7.54596"
        width="53.3047"
        height="53.1589"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_86_23538"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_86_23538"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_86_23538"
        x="37.6963"
        y="7.86945"
        width="51.3994"
        height="51.1106"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_86_23538"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_86_23538"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_86_23538"
        x="13.6475"
        y="8.59967"
        width="52.8672"
        height="51.8733"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_86_23538"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_86_23538"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_86_23538"
        x1="62.1176"
        y1="18.2419"
        x2="61.046"
        y2="27.8945"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#68728B" />
        <stop
          offset="0.9964"
          stop-color="#646E87"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_86_23538"
        x1="66.1313"
        y1="18.334"
        x2="60.7594"
        y2="26.4435"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#68728B" />
        <stop
          offset="0.9964"
          stop-color="#646E87"
        />
      </linearGradient>
      <clipPath id="clip0_86_23538">
        <rect
          width="2.10262"
          height="6.22148"
          fill="white"
          transform="matrix(0.764914 -0.644132 0.64818 0.761487 36.9258 20.9429)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
